import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellOff, Bell } from "lucide-react";

const API = `${window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("session_token")}` } });

// Lets staff stop (or undo) the automatic 5-day review reminder for this one customer.
export function ReviewReminderBanner({ customerId }) {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => axios.get(`${API}/review-tracking/customer/${customerId}/followup`, auth())
    .then((r) => setState(r.data)).catch(() => setState(null));
  useEffect(() => { if (customerId) load(); }, [customerId]); // eslint-disable-line react-hooks/exhaustive-deps

  const act = async (action) => {
    setBusy(true);
    try {
      await axios.post(`${API}/review-tracking/customer/${customerId}/${action}-followup`, {}, auth());
      toast.success(action === "stop" ? "Review reminder stopped for this customer" : "Review reminder turned back on");
      await load();
    } catch { toast.error("Couldn't update the review reminder"); } finally { setBusy(false); }
  };

  if (!state || (!state.pending && !state.stopped)) return null;
  const stopped = !state.pending && state.stopped;
  return (
    <div className="bg-zinc-50 border-b border-zinc-200 px-4 py-2 flex items-center gap-2 text-sm" data-testid="review-reminder-banner">
      {stopped ? <BellOff className="w-4 h-4 text-zinc-500" /> : <Bell className="w-4 h-4 text-[#207024]" />}
      <span className="flex-1 text-zinc-700" data-testid="review-reminder-status">
        {stopped ? "Review reminder stopped for this customer."
          : state.replied ? "Review reminder won't send (they replied). Stop it to make sure."
            : "A review reminder text is scheduled for this customer."}
      </span>
      <button disabled={busy} onClick={() => act(stopped ? "resume" : "stop")}
        className={`text-xs font-semibold px-3 py-1 rounded-full ${stopped ? "text-[#207024] border border-[#207024]" : "bg-red-50 text-red-600 border border-red-200"}`}
        data-testid={stopped ? "review-reminder-resume-btn" : "review-reminder-stop-btn"}>
        {stopped ? "Undo" : "Stop reminder"}
      </button>
    </div>
  );
}
